var _rect, _path, _path2, _path3, _line, _line2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelfPacedVideos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 399,
    height: 240,
    viewBox: "0 0 399 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 82.5,
    width: 159,
    height: 89,
    rx: 7.5,
    stroke: "#3C3E4C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.5 127C177.5 117.335 185.335 109.5 195 109.5C199.641 109.5 204.092 111.344 207.374 114.626C210.656 117.908 212.5 122.359 212.5 127C212.5 136.665 204.665 144.5 195 144.5C185.335 144.5 177.5 136.665 177.5 127ZM191.798 134.49L202 128.12C202.382 127.875 202.613 127.453 202.613 127C202.613 126.547 202.382 126.124 202 125.88L191.763 119.51C191.359 119.256 190.85 119.24 190.432 119.469C190.014 119.698 189.753 120.136 189.75 120.613V133.388C189.744 133.876 190.01 134.327 190.44 134.558C190.87 134.79 191.393 134.763 191.798 134.49Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M351 82.5H397.5V171.5H351C346.858 171.5 343.5 168.142 343.5 164V90C343.5 85.8579 346.858 82.5 351 82.5Z",
    stroke: "url(#paint0_linear_1649_3505)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 171.5L0.5 171.5L0.500008 82.5L39 82.5C43.1421 82.5 46.5 85.8579 46.5 90L46.5 164C46.5 168.142 43.1421 171.5 39 171.5Z",
    stroke: "url(#paint1_linear_1649_3505)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 284,
    y1: 126.5,
    x2: 334,
    y2: 126.5,
    stroke: "white",
    strokeDasharray: "4 4"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 126.5,
    x2: 106,
    y2: 126.5,
    stroke: "white",
    strokeDasharray: "4 4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1649_3505",
    x1: 343,
    y1: 127,
    x2: 398,
    y2: 127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3E4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#05060C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1649_3505",
    x1: 47,
    y1: 127,
    x2: -0.00000369537,
    y2: 127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3E4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#05060C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfPacedVideos);
export default __webpack_public_path__ + "static/media/Self_Paced_Videos.524bcb5663de6c502bdbb13cbfd41d01.svg";
export { ForwardRef as ReactComponent };